import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of, switchMap } from 'rxjs';
import { AUTH_ROUTES } from '../constants/routes';

@Injectable()
export class CanAccessRoute implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isAuthorized().pipe(
      switchMap((isAuthorized) => {
        if (state.url.includes('auth')) {
          return this.canActivateAuthUrl(isAuthorized, state.url);
        }

        return this.canActivatePrivateUrl(isAuthorized);
      })
    );
  }

  canActivatePrivateUrl(isAuthorized: boolean): Observable<boolean> {
    if (isAuthorized) {
      return of(true);
    }

    this.router.navigate(['']);
    return of(false);
  }

  canActivateAuthUrl(isAuthorized: boolean, url: string): Observable<boolean> {
    if (
      isAuthorized &&
      [
        AUTH_ROUTES.LOGIN,
        AUTH_ROUTES.REGISTRATION,
        AUTH_ROUTES.REGISTRATION_TYPE,
      ].some((route) => url.includes(route))
    ) {
      this.router.navigate(['']);
      return of(false);
    }

    return of(true);
  }
}
